import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl';
import ProcessHandlingListContext from '../../../../components/ProcessHandlingListContext';
import Button from '@material-ui/core/Button';
import Dialog from '@afosto/app-components-react/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { bulk as bulkApi } from '@afosto/fulfilment/api/Bulk';
import translations from './translations';

const PickAllDialog = ({ currentParcel, isOpen, onCancel, onSuccess }) => {
  const intl = useIntl();
  const { handlingList, shouldPack } = useContext(ProcessHandlingListContext);
  const { enqueueSnackbar } = useSnackbar();

  const handlePickAll = async () => {
    try {
      await bulkApi.bulkUpdateItems({
        command: 'set_parameters',
        parameters: {
          is_handled: true,
          ...(shouldPack && currentParcel
            ? {
                parcel_id: currentParcel.id,
              }
            : {}),
        },
        constraints: [
          {
            key: 'list_ids',
            operator: 'in',
            value: [handlingList?.id],
          },
          {
            key: 'is_handled',
            operator: 'in',
            value: false,
          },
          {
            key: 'is_finished',
            operator: 'in',
            value: false,
          },
          {
            key: 'is_missing',
            operator: 'in',
            value: false,
          },
        ],
      });

      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    } catch (err) {
      enqueueSnackbar(
        intl.formatMessage(
          translations.feedback[shouldPack ? 'pickAndPackAllFailed' : 'pickAllFailed'],
        ),
        {
          variant: 'error',
        },
      );
    }
  };

  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>
        <FormattedMessage {...translations[shouldPack ? 'packTitle' : 'title']} />
      </DialogTitle>
      <DialogContent>
        <FormattedMessage {...translations[shouldPack ? 'packMessage' : 'message']} />
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button variant="contained" onClick={onCancel}>
          <FormattedMessage {...translations.actions.cancel} />
        </Button>
        <Button color="primary" variant="contained" onClick={handlePickAll}>
          <FormattedMessage {...translations.actions[shouldPack ? 'pickAndPackAll' : 'pickAll']} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PickAllDialog.propTypes = {
  currentParcel: PropTypes.object,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  shouldPack: PropTypes.bool,
};

PickAllDialog.defaultProps = {
  currentParcel: undefined,
  isOpen: false,
  onCancel: undefined,
  onSuccess: undefined,
  shouldPack: false,
};

export default PickAllDialog;
